export default [
  [`Размер`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Длина рукава (см)`, `17.5`, `18.5`, `19.5`, `20.5`, `21.5`, `22.5`],
  [`Высота по спинке (см)`, `69.5`, `71.5`, `73.5`, `75.5`, `77.5`, `79.5`],
  [
    `Ширина под проймой, 2.5см под рукавом (см)`,
    `47.5`,
    `50.5`,
    `53.5`,
    `56.5`,
    `59.5`,
    `62.5`
  ]
];
